export const environment = {
    production: false,
    baseUrl: "https://platforma.dev2.bdomobile.com",
    apiUrl: "https://server.dev2.bdomobile.com",
    accountsApiUrl: "https://server.dev2.bdomobile.com/accounts",
    authApiUrl: "https://server.dev2.bdomobile.com/uaa",
    keycloakUrl: "https://keycloak-dev.mobiletract.com",
    adminPanelUrl: "https://admin.dev2.bdomobile.com",
    platformWebUrl: "https://platforma.dev2.bdomobile.com",
    webPanelUrl: "https://panel.dev2.bdomobile.com",
    realm: "bdo-dev2",
    clientId: "ekowitryna_kobize_web",
    googleTagManagerId: 'GTM-XXXXXX',
    googleTagManagerPreview: 'env-3',
    googleTagManagerAuth: 'nwRCCNlB1-SPt0eiDeFIOw',
    bypassAuth: false
  };